<template>
    <el-dialog
        :visible.sync="viewDetails"
        :close-on-click-modal="true"
        width="95%"
        top="0"
        custom-class="customClass category-details"
        :lock-scroll="true"
        :before-close="closeModal"
    >
        <el-row :gutter="20">
            <el-col :span="24" class="text-left px-4">
                <el-card>
                    <el-button size="small" class="submit-btn" icon="el-icon-back" @click="closeModal">Back</el-button>
                    <task-dashboard-filter
                        :outlet-lists="outletLists"
                        :calendar-type-list="calendarTypeList"
                        :task-intermediate-categories="taskIntermediateCategories"
                        :audit-intermediate-categories="auditIntermediateCategories"
                        :initial-from-date="fromDate"
                        :initial-to-date="toDate"
                        :dashboard-tab="dashboardTab"
                        :selected-type="selectedType"
                        :selected-intermediate-category="intermediateCategory"
                        @changedSelectedOutlet="changedSelectedOutlet"
                        @changedDateTypeView="changedDateTypeView"
                        @changedFromDate="changedFromDate"
                        @changedToDate="changedToDate"
                        @changedSelectedAuditType="changedSelectedAuditType"
                    ></task-dashboard-filter>
                </el-card>
            </el-col>
        </el-row>
        <el-row :gutter="20" class="my-4">
            <el-col :span="24">
                <el-card>
                    <div class="grid-content text-center my-4">
                        <h4>Performance - By Category</h4>
                    </div>
                    <div style="width: 100%; height: 300px">
                        <category-insight-dashboard-graph
                            :graph-values="graphValues"
                            :graph-labels="graphLabels"
                            :graph-colors="graphColors"
                        ></category-insight-dashboard-graph>
                    </div>
                </el-card>
            </el-col>
        </el-row>
        <el-row :gutter="20" class="my-4">
            <el-col :span="24">
                <el-card class="category-details-graph-table-container-card">
                    <div class="text-right mb-2">
                        <el-input v-model="searched_location" size="mini" style="max-width: 240px" placeholder="Search by location">
                            <i slot="prefix" class="el-input__icon el-icon-search"></i>
                        </el-input>
                        <el-button class="btn submit-btn" size="mini" icon="el-icon-download" style="margin-left: 10px;" @click="downloadCategoryPerformanceDetails()">Download Reports</el-button>
                    </div>
                    <template v-if="paginatedData.length">
                        <el-table
                            :data="paginatedData"
                            style="width: 100%"
                            height="500"
                            class="custom-category__details-table"
                        >
                            <el-table-column
                                fixed
                                align="center"
                                width="240"
                            >
                                <template slot="header" slot-scope="scope">
                                    Location
                                    <el-popover placement="right" trigger="click">
                                        <el-input
                                            v-model="searched_filter_location"
                                            size="mini"
                                            placeholder="Search Location"
                                        ></el-input>
                                        <div
                                            style="max-height: 250px; overflow: auto; margin-top: 10px"
                                        >
                                        <el-checkbox-group v-model="selected_locations">
                                            <el-checkbox
                                            v-for="(locationItem, index) in allLocations.filter(
                                                (el) =>
                                                !searched_filter_location ||
                                                el.toLowerCase().includes(searched_filter_location.toLowerCase())
                                            )"
                                            :key="index"
                                            class="mb-2 checkbox-lable"
                                            :label="locationItem"
                                            style="display: block"
                                            ></el-checkbox>
                                        </el-checkbox-group>
                                        </div>
                                        <div class="flex justify-between mt-4">
                                        <span
                                            class="text-xs cursor-pointer primary-theme-color"
                                            @click="selected_locations = [...allLocations]"
                                            >Select all</span
                                        >
                                        <span
                                            class="text-xs cursor-pointer"
                                            @click="selected_locations = [];"
                                            >Reset</span
                                        >
                                        </div>
                                        <span slot="reference">
                                        <img
                                            v-if="selected_locations.length"
                                            src="../../../../../../assets/images/filter.png"
                                            width="9"
                                            class="cursor-pointer"
                                        />
                                        <img
                                            v-else
                                            src="../../../../../../assets/images/filter-icon.png"
                                            width="9"
                                            class="cursor-pointer"
                                        />
                                        </span>
                                    </el-popover>
                                </template>
                                <template slot-scope="scope">
                                    <span class="capitalize">{{ scope.row.Location }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                align="center"
                                width="200"
                            >
                                <template slot="header" slot-scope="scope">
                                    Region
                                    <el-popover placement="right" trigger="click">
                                        <el-input
                                            v-model="searched_filter_region"
                                            size="mini"
                                            placeholder="Search Sub Region"
                                        ></el-input>
                                        <div
                                            style="max-height: 250px; overflow: auto; margin-top: 10px"
                                        >
                                        <el-checkbox-group v-model="selected_regions">
                                            <el-checkbox
                                            v-for="(locationItem, index) in allRegions.filter(
                                                (el) =>
                                                !searched_filter_region ||
                                                el.toLowerCase().includes(searched_filter_region.toLowerCase())
                                            )"
                                            :key="index"
                                            class="mb-2 checkbox-lable"
                                            :label="locationItem"
                                            style="display: block"
                                            ></el-checkbox>
                                        </el-checkbox-group>
                                        </div>
                                        <div class="flex justify-between mt-4">
                                        <span
                                            class="text-xs cursor-pointer primary-theme-color"
                                            @click="selected_regions = [...allRegions]"
                                            >Select all</span
                                        >
                                        <span
                                            class="text-xs cursor-pointer"
                                            @click="selected_regions = [];"
                                            >Reset</span
                                        >
                                        </div>
                                        <span slot="reference">
                                        <img
                                            v-if="selected_regions.length"
                                            src="../../../../../../assets/images/filter.png"
                                            width="9"
                                            class="cursor-pointer"
                                        />
                                        <img
                                            v-else
                                            src="../../../../../../assets/images/filter-icon.png"
                                            width="9"
                                            class="cursor-pointer"
                                        />
                                        </span>
                                    </el-popover>
                                </template>
                                <template slot-scope="scope">
                                    <span class="capitalize">{{ scope.row.Region }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                align="center"
                                width="200"
                            >
                                <template slot="header" slot-scope="scope">
                                    Sub Region
                                    <el-popover placement="right" trigger="click">
                                        <el-input
                                            v-model="searched_filter_subregion"
                                            size="mini"
                                            placeholder="Search Sub Region"
                                        ></el-input>
                                        <div
                                            style="max-height: 250px; overflow: auto; margin-top: 10px"
                                        >
                                        <el-checkbox-group v-model="selected_subregions">
                                            <el-checkbox
                                            v-for="(locationItem, index) in allSubRegions.filter(
                                                (el) =>
                                                !searched_filter_subregion ||
                                                el.toLowerCase().includes(searched_filter_subregion.toLowerCase())
                                            )"
                                            :key="index"
                                            class="mb-2 checkbox-lable"
                                            :label="locationItem"
                                            style="display: block"
                                            ></el-checkbox>
                                        </el-checkbox-group>
                                        </div>
                                        <div class="flex justify-between mt-4">
                                        <span
                                            class="text-xs cursor-pointer primary-theme-color"
                                            @click="selected_subregions = [...allSubRegions]"
                                            >Select all</span
                                        >
                                        <span
                                            class="text-xs cursor-pointer"
                                            @click="selected_subregions = [];"
                                            >Reset</span
                                        >
                                        </div>
                                        <span slot="reference">
                                        <img
                                            v-if="selected_subregions.length"
                                            src="../../../../../../assets/images/filter.png"
                                            width="9"
                                            class="cursor-pointer"
                                        />
                                        <img
                                            v-else
                                            src="../../../../../../assets/images/filter-icon.png"
                                            width="9"
                                            class="cursor-pointer"
                                        />
                                        </span>
                                    </el-popover>
                                </template>
                                <template slot-scope="scope">
                                    <span class="capitalize">{{ scope.row['Sub Region'] }}</span>
                                </template>
                            </el-table-column>
                            <template v-for="(item, index) in performanceResults.labels.filter(el => el !== 0 && el !== null && el !== undefined)">
                                <el-table-column
                                    v-if="item != 'Location' && item != 'Region' && item != 'Sub Region'"
                                    :key="'table-item-'+index"
                                    min-width="200"
                                    align="center"
                                >
                                    <template slot="header" slot-scope="scope">
                                        {{ item }}
                                        <i v-if="sortColumn == item && sortBy == 'desc'" class="el-icon-caret-top icon-white cursor-pointer" @click="handleSorting(item, 'asc')"></i>
                                        <i v-else-if="sortColumn == item && sortBy == 'asc' || sortBy == ''" class="el-icon-caret-bottom icon-white cursor-pointer" @click="handleSorting(item, 'desc')"></i>
                                        <i v-else class="el-icon-caret-bottom icon-black cursor-pointer" @click="handleSorting(item, 'desc')"></i>
                                    </template>
                                    <template slot-scope="scope">
                                        {{ scope.row[item] || scope.row[item] == 0 ? scope.row[item] : "-" }}
                                    </template>
                                </el-table-column>
                            </template>
                        </el-table>

                        <el-row :gutter="20" class="mt-4">
                            <el-col :span="8" class="text-left">
                                <div>
                                    <b>Showing</b> {{ startNumber }} to {{ endNumber }} of {{ local_performanceResults.length }} results
                                </div>
                            </el-col>
                            <el-col :span="8" class="text-center">
                            <el-select v-model="perPage" name="per_page" placeholder="select per page" style="width: 90px !important;" size="mini">
                                <el-option label="10" :value="10"></el-option>
                                <el-option label="25" :value="25"></el-option>
                                <el-option label="50" :value="50"></el-option>
                                <el-option label="100" :value="100"></el-option>
                            </el-select>
                            &nbsp;<b>per page</b>
                            </el-col>
                            <el-col :span="8" class="text-right">
                            <el-pagination
                                background
                                layout="prev, pager, next"
                                :total="local_performanceResults.length"
                                :page-size="perPage"
                                :current-page.sync="currentPage"
                            ></el-pagination>
                            </el-col>
                        </el-row>
                    </template>
                </el-card>
            </el-col>
        </el-row>
    </el-dialog>
</template>

<script>
import exportFromJSON from 'export-from-json';
import CategoryInsightDashboardGraph from "./CategoryInsightDashboardGraph.vue";
import TaskDashboardFilter from "../../TaskComponents/TaskDashboardFilter.vue";
export default {
    name: "CategoryPerformanceDetails",
    components: {
        CategoryInsightDashboardGraph,
        TaskDashboardFilter
    },
    props: {
		fromDate: {
			type: String,
			default: "",
		},
		toDate: {
			type: String,
			default: "",
		},
        selectedGraphValueType: {
            type: String,
            default: ""
        },
        performanceResults: {
            type: Object,
            default: () => {}
        },
        taskCategories: {
            type: Array,
            default: () => []
        },
        viewDetails: {
            type: Boolean,
            default: false
        },
        dashboardTab: {
            type: String,
            default: "audit"
        },
        outlet: {
            type: String,
            default: null
        },
        graphValues: {
            type: Array,
            default: () => []
        },
        graphLabels: {
            type: Array,
            default: () => []
        },
        graphColors: {
            type: Array,
            default: () => []
        },
        auditIntermediateCategories: {
			type: Array,
			required: false,
			default: () => []
		},
		taskIntermediateCategories: {
			type: Array,
			required: false,
			default: () => []
		},
        outletLists: {
            required: true,
            type: Array,
        },
        calendarTypeList: {
            required: true,
            type: Array
        },
		intermediateCategory: {
			type: String,
			default: "",
		},
		selectedType: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
			searched_location: "",
            selected_locations: [],
            searched_filter_location: "",
            searched_filter_region: "",
            selected_regions: [],
            searched_filter_subregion: "",
            selected_subregions: [],
            sortColumn: "",
            sortBy: "desc",
            show_table: false,
            currentPage: 1,
            perPage: 10,
        }
    },
    computed: {
        local_performanceResults() {
            let result = [...this.performanceResults.data];

            if(this.searched_location) {
                result = result.filter(el => el.Location.toLowerCase().includes(this.searched_location.toLowerCase()));
            }

            if(this.selected_locations && this.selected_locations.length) {
                result = result.filter(el => this.selected_locations.includes(el.Location));
            }
            if(this.selected_regions && this.selected_regions.length) {
                result = result.filter(el => this.selected_regions.includes(el.Region));
            }
            if(this.selected_subregions && this.selected_subregions.length) {
                result = result.filter(el => this.selected_subregions.includes(el['Sub Region']));
            }

            if(this.sortColumn && this.sortBy) {
                let arrOne = result.filter(el => el[this.sortColumn]);
                let arrTwo = result.filter(el => !el[this.sortColumn]);
                if(this.sortBy == 'desc') {
                    result = [arrOne.sort((a, b) => b[this.sortColumn] - a[this.sortColumn]), ...arrTwo];
                } else {
                    result = [arrOne.sort((a, b) => a[this.sortColumn] - b[this.sortColumn]), ...arrTwo];
                }
            }

            return result;
        },
        allLocations() {
            if(this.performanceResults && this.performanceResults.data && this.performanceResults.data.length) {
                return [...new Set(this.performanceResults.data.map(el => el.Location))];
            } else {
                return [];
            }
        },
        allRegions() {
            if(this.performanceResults && this.performanceResults.data && this.performanceResults.data.length) {
                return [...new Set(this.performanceResults.data.map(el => el.Region))];
            } else {
                return [];
            }
        },
        allSubRegions() {
            if(this.performanceResults && this.performanceResults.data && this.performanceResults.data.length) {
                return [...new Set(this.performanceResults.data.map(el => el['Sub Region']))];
            } else {
                return [];
            }
        },
        startNumber() {
            let start = (this.currentPage * this.perPage) - (this.perPage - 1);
            return start;
        },
        endNumber() {
            let end = Math.min(this.startNumber + this.perPage - 1, this.local_performanceResults.length);
            return end;
        },
        paginatedData() {
            return this.local_performanceResults.filter((el, index) => index >= this.startNumber - 1 && index < this.endNumber);
        },
    },
    methods: {
        changedSelectedOutlet(event) {
            this.$emit('changedSelectedOutlet', event);
        },
        changedDateTypeView(event) {
            this.$emit('changedDateTypeViewList', event);
        },
        changedFromDate(event) {
            this.$emit('changedFromDate', event);
        },
        changedToDate(event) {
            this.$emit('changedToDate', event)
        },
        changedSelectedAuditType(event) {
            this.$emit('changedSelectedAuditType', event);
        },
        closeModal() {
            this.$emit('closeCategoryDetailsModal', false);
        },
        locationFilterHandler(value, row, column) {
            const property = row['Location'];
            return value == property;
        },
        regionFilterHandler(value, row, column) {
            const property = row['Region'];
            return value == property;
        },
        subRegionFilterHandler(value, row, column) {
            const property = row['Sub Region'];
            return value == property;
        },
        downloadCategoryPerformanceDetails() {
            let data = this.performanceResults.data.map(el => ({
                ...el
            }));
            const fileName = 'Category_Performance_Results';
            const exportType = exportFromJSON.types.csv;
            exportFromJSON({ data, fileName, exportType });
        },
        downloadCategoryData() {
            let data = this.taskCategories.data.map(el => ({
                ...el
            }));
            const fileName = 'Category_Performance_Results';
            const exportType = exportFromJSON.types.csv;
            exportFromJSON({ data, fileName, exportType });
        },
        distinct(value, index, self) {
            return self.indexOf(value) === index;
        },
        handleSorting(column, order) {
            this.sortColumn = column;
            this.sortBy = order;
        },
    },
}
</script>

<style lang="scss">
    .el-table.custom-category__details-table {
		th {
			min-height: 35px !important;
		}
        .el-table__header-wrapper {
            table {
                thead {
                    th {
                        background-color: #502314 !important;
                        .cell {
                            color: #fff !important;
                        }
                    }
                    th.el-table__cell {
                        background-color: #502314 !important;
                        .cell {
                            color: #fff !important;
                        }
                    }
                }
            }
        }
    }
    .el-table.custom-category__details-table th.el-table__cell {
        background-color: #502314 !important;
		th {
			min-height: 35px !important;
		}
        .cell {
            color: #fff !important;
        }
    }
    .customClass.category-details {
        background: #fff;
    }
</style>

<style>
.customClass.category-details .el-table td.el-table__cell div {
    text-transform: capitalize !important;
}
.customClass.category-details .category-details-graph-table-container-card .el-table th.el-table__cell {
    min-height: fit-content !important;
}
.customClass.category-details .category-details-graph-table-container-card .el-table th.el-table__cell {
    padding: 8px 0 !important;
}
.customClass.category-details .category-details-graph-table-container-card .icon-white {
    color: #FFF;
}
</style>
